module.exports = __webpack_public_path__ + "sz.3fd422e9.svg";